import { render, staticRenderFns } from "./Plano.vue?vue&type=template&id=374ccb47&lang=pug&"
import script from "./Plano.vue?vue&type=script&lang=ts&"
export * from "./Plano.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports